import { render, staticRenderFns } from "./EditTerms.vue?vue&type=template&id=6b3c2afd&scoped=true&"
import script from "./EditTerms.vue?vue&type=script&lang=js&"
export * from "./EditTerms.vue?vue&type=script&lang=js&"
import style0 from "./EditTerms.vue?vue&type=style&index=0&id=6b3c2afd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3c2afd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b3c2afd')) {
      api.createRecord('6b3c2afd', component.options)
    } else {
      api.reload('6b3c2afd', component.options)
    }
    module.hot.accept("./EditTerms.vue?vue&type=template&id=6b3c2afd&scoped=true&", function () {
      api.rerender('6b3c2afd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/EditTerms.vue"
export default component.exports